import React from 'react';
import * as d3 from "d3";
import {decodePolyline} from '../Util'

var color = '#2196f3';
var strokeWidth = 1;

class GridMap extends React.Component {

    componentDidMount() {

        if (this.props.activities.length > 0) {
            this.display(this.props.activities);
        }
    }

    computeGrid(n, width,height){
        var min_waste = -1
        var best_counts = null
        var best_size = null
        for(var count_x=1;count_x<n+1;count_x++){
            var size_x = width / count_x
            for(var count_y=1;count_y<n+1;count_y++){
                if(count_x*count_y>=n){
                    var size_y = height / count_y
                    var size = Math.min(size_x, size_y)
                    var waste = width * height - n * size * size
                    if(waste<0){
                        continue;
                    }else{
                        if(best_size ===null || waste < min_waste){
                            best_size = size
                            best_counts = [count_x, count_y]
                            min_waste = waste
                        }
                    }
                }
            }
        }
        return [best_size, best_counts]
    }
    display(activities) {

        if(activities.length===0){
            d3.select(this.container).selectAll('g').remove();
            return;
        }

        var width = this.props.poster.layout.width-this.props.poster.layout.margin*2; //400
        var height = this.props.poster.layout.height-this.props.poster.legend.height-this.props.poster.legend.spacer-this.props.poster.layout.margin*2;//500;

        var computedGrid=this.computeGrid(activities.length,width,height);
        console.log(computedGrid);
        



        d3.select(this.container).selectAll('g').remove();

        var svg = d3.select(this.container).selectAll('g')
            .data([0])
            .enter()
            .append("g")
            .attr("width", width)
            .attr("height", height)
            .attr("class", "RdYlGn")

        /*rect = svg.selectAll(".day")
            .data(function (d) {
                console.log(d);
                return activities;
            })
            .enter().append("rect")
            .attr("class", "day")
            .attr("width", computedGrid[0])
            .attr("height", computedGrid[0])
            .attr("x", function (d) {
                var index=activities.indexOf(d);
                return index%computedGrid[1][0] * computedGrid[0] ;
            })
            .attr("y", function (d) {
                var index=activities.indexOf(d);
                return Math.floor(index/computedGrid[1][0]) * computedGrid[0];
            });*/

            var style = this.props.poster.style;
            var margin = +this.props.poster.layout.margin;
            color = style.route.color;
            strokeWidth = style.route.strokeWidth;
            //rect.style("fill", function (d) { return "#000"; });
            activities.sort(function(a, b) {
                return new Date(a.start_date) - new Date(b.start_date);
             });
            activities.forEach(function (activity,index) {
                console.log(activity)
                if(activity.map.summary_polyline){
                    var feature = {
                        type: "Feature",
                        properties: {},
                        geometry: {
                            type: "LineString",
                            //coordinates: decodePolyline(activity.map.summary_polyline).map(function (elt) { return [elt[1], elt[0]] })
                            coordinates: decodePolyline(activity.map.summary_polyline).map(function (elt) { return [elt[1], elt[0]] })
                        }
                    };
                    var scale = 0.9;
                    var projection = d3.geoMercator().fitExtent([[0, 0], [computedGrid[0]*scale, computedGrid[0]*scale]], feature);
    
                    var path = d3.geoPath().projection(projection);
                    svg.selectAll(".track").data([0]).enter().append("path").attr("transform",function(d){
                        console.log(index);
                        var x = index%computedGrid[1][0] * computedGrid[0]+(width-computedGrid[0]*computedGrid[1][0])/2+computedGrid[0]*(1-scale)/2+margin;
                        var y = Math.floor(index/computedGrid[1][0]) * computedGrid[0]+(height-computedGrid[0]*computedGrid[1][1])/2+computedGrid[0]*(1-scale)/2+margin;
                        return 'translate('+x+' '+y+')';
                    }).datum(feature).attr('d', path)
                    .style('stroke',style.route.color)
                    .style('stroke-width',style.route.strokeWidth)
                    .style('stroke-linejoin','round')
                    .style('fill','none')
                }
                
            });

            

    }

    shouldComponentUpdate(nextProps) {
        if(this.props.poster.style.route.color!==color){
            this.display(nextProps.activities);
            return true;
        }
        if(this.props.poster.style.route.strokeWidth!==strokeWidth){
            this.display(nextProps.activities);
            return true;
        }
        if (this.props.activities.length !== nextProps.activities.length) {
            this.display(nextProps.activities);
            return true
        }
        if (this.props.activities.length > 0 && this.props.activities[0].id === nextProps.activities[0].id) {
            return false
        } else {
            if (nextProps.activities.length > 0) {
                this.display(nextProps.activities);
            }

            return true
        }
    }

    render() {
        return (

            <g id='gridmap' ref={(node) => this.container = node} />
        )
    }
}

export default GridMap;


// WEBPACK FOOTER //
// ./src/components/GridMap.js